import { render, staticRenderFns } from "./border-button.vue?vue&type=template&id=55aeb47c&scoped=true&"
import script from "./border-button.vue?vue&type=script&lang=ts&"
export * from "./border-button.vue?vue&type=script&lang=ts&"
import style0 from "./border-button.vue?vue&type=style&index=0&id=55aeb47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aeb47c",
  null
  
)

component.options.__file = "border-button.vue"
export default component.exports